// src/App.js
import React from "react";
import { Routes, Route } from "react-router-dom";

import Home from "./Home";
import PrivacyPolicy from "./PrivacyPolicy";
import TermsOfUse from "./TermsOfUse";
import About from "./About";
import ActivateAccount from "./ActivateAccount";
import ResetPassword from "./ResetPassword";
import PrivacyPolicy2 from "./PrivacyPolicy2";
import AccountDeletion from "./AccountDeletion";

function App() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/privacypolicy" element={<PrivacyPolicy2 />} />
      <Route path="/terms-of-use" element={<TermsOfUse />} />
      <Route path="/about" element={<About />} />
      <Route path="/auth/activate/:token" element={<ActivateAccount />} />
      <Route path="/auth/reset-password/:token" element={<ResetPassword />} />
      <Route path="/accountdelete" element={<AccountDeletion />} />
    </Routes>
  );
}

export default App;
